__webpack_require__.p = "/scripts/bundles/dist/";